import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, SwitchAppButton } from "../../components"

import plusIcon from "../../assets/icons/plus-icon.svg"
import brandLogo from "../../assets/icons/upload-brandlogo.svg"
import { Link } from "react-router-dom"

export const View = () =>{
 const Brandcolor= ({colortype,color,colorcode}:
    {colortype:string,color:string,colorcode:string})=>{
    return(
       
            <div className="display-flex gap-between-06 color-picker-content">
                <div className="new-color-type">{colortype}</div>
                <div className="new-color-picker">{color}</div>
                <div className="new-color-code">{colorcode}</div>
            </div>

       
    )

 }
 const Brandcolor2= ({colortype,color,colorcode}:
    {colortype:string,color:string,colorcode:string})=>{
    return(
       
            <div className="display-flex gap-between-06 color-picker-content">
                <div className="new-color-type">{colortype}</div>
                <div className="new-color-picker-accent">{color}</div>
                <div className="new-color-code">{colorcode}</div>
            </div>

       
    )

 }

    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Branding"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <Card>
      <div className="branding-section-header">
                <strong>Brand customisation</strong>
                <p>Customize how your brand appears globally across the Stripe products your customers use.</p>
            </div>
            <div className="branding-contents">
                <div className="branding-left-section">
                   <div className="brand-element">
                        <strong>Brand elements</strong>
                   </div>
                   <div className="brand-element">
                    <p >Logo:</p>
                    <div className="brand-logo-space ">
                    <div className="brand-logo-contents">
                        <img src={brandLogo} alt="brand-logo" />
                        <img src={plusIcon} alt="plus-icon" />
                        <span>Click to here to upload</span>
                    </div>
                   </div>
                   </div>
                   <div className="brand-element">
                        <Brandcolor
                        colortype="Brand color"
                        colorcode="#491034"
                        color=""
                        />
                         <Brandcolor2
                        colortype="Accent color"
                        colorcode="#020D88"
                        color=""
                        />
                   </div>
                   
                </div>
                <div className="branding-right-section ">
                     <strong>Preview</strong>
                     <div className="branding-right-section-container ">
                        <div className="branding-right-nav">
                            <nav>
                            <Link to={"/receipts"}> Receipts</Link>
                            <Link to={"/receipts"}> Checkouts and payment links</Link>
                            <Link to={"/receipts"}> Invoice</Link>
                            </nav>
                        </div>
                        <SwitchAppButton
                className="branding-success-btn"
                kind="success"  onClick={ () =>{("")} }            
                >Send a test receipt</SwitchAppButton>
                <div className="inner-card">
                    <div className="inner-card-colored">
                        <strong>Payment Received</strong>
                    </div>
                    <div className="inner-card-details">
                    <div className="card-detail-total ">
                        
                        </div>
                    </div>
                    
                </div>
                
                     </div>
                     
                </div>
            </div>
     
      </Card>
        </>
    )
}
